var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.2 58.2",
    style: {
      enableBackground: "new 0 0 58.2 58.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C1412;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hot",
    className: "st0",
    d: "M29.1,58.2C13,58.2,0,45.1,0,29.1C0,13,13,0,29.1,0s29.1,13,29.1,29.1C58.2,45.1,45.1,58.2,29.1,58.2z  M29.1,2.8C14.6,2.8,2.8,14.6,2.8,29.1c0,14.5,11.8,26.2,26.2,26.2c14.5,0,26.2-11.8,26.2-26.2C55.3,14.6,43.6,2.8,29.1,2.8z  M47.6,19.9c5.6,1,4.4,6.7,4.4,6.8c-1.8-1.8-5.8-5.5-13.4-3.6c1.3-2.5,4-3.2,4.3-3.2c-0.1-1.7-1.3-3.4-3.4-4.6 c1.5-0.1,4.6-1.4,5.4-1.9C48,15.8,47.8,19.3,47.6,19.9z M34.9,26.7c-8.4,8.6-28.7,7.4-25.3-9.3C-6.4,43.5,35,64.6,50.4,37 C57.2,24.8,40.3,21.1,34.9,26.7z M43.3,32.3C35.2,42.8,7.5,42.4,8.4,25.8c2.8,13.1,22.6,11.9,28.4,3.5c1.4-2,2.7-3.1,4.4-3.1 C44.1,26.2,46.5,28.2,43.3,32.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.47f9014d7522653f360925c2e7333cd6.svg";
export { ForwardRef as ReactComponent };